import { reducer as system } from "features/System";
import { reducer as sheets } from "features/Sheets";
import { reducer as settings } from "features/Settings";
import { reducer as agreements } from "features/Agreements";
import { reducer as userNotifications } from "features/Notifications";

export default {
  system,
  sheets,
  settings,
  agreements,
  userNotifications,
};
